import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { removeBlank } from 'src/app/core/helpers';
import { ApiService } from 'src/app/core/services/api.service';
import { TestDownloadableAsset } from '../constants';





@Injectable({providedIn: 'root'})
export class TestRecordsListService extends ApiService {

  public getTest(params?): Observable<any> {
    return this.request({
      path: 'tests/',
      method: 'GET',
      query: removeBlank(params)
    });
  }

  public getTestPacketLogs(params: {
    testId: number, page: number;
    limit: number;
  }): Observable<any> {
    return this.request({
      path: `tests/${params.testId}/packet-logs`,
      method: 'GET',
      query: removeBlank(params)
    });
  }



  public download(
    testId: string,
    type: TestDownloadableAsset,
    selectedReportType?: string
  ): Observable<{ signedUrl: string }> {

    const params = new URLSearchParams();
    params.set('type', type);

    if (selectedReportType) {
      params.set('selectedReportType', selectedReportType);
    }

    return this.request({
      path: `tests/${testId}/download?${params.toString()}`,
      method: 'GET',
    });
  }



  public getTestWebhookLogs(params: {
    testId: number, page: number;
    limit: number;
  }): Observable<any> {
    return this.request({
      path: `tests/${params.testId}/webhook-logs`,
      method: 'GET',
      query: removeBlank(params)
    });
  }


  public getTestAlgoLogs(params: {
    testId: number, page: number;
    limit: number;
  }): Observable<any> {
    return this.request({
      path: `tests/${params.testId}/algo-logs`,
      method: 'GET',
      query: removeBlank(params)
    });
  }


  public getUsers(params): Observable<any> {
    return this.request({
      path: 'users/',
      method: 'GET',
      query: params
    });
  }

  public deleteAnnotations(id): Observable<any> {
    return this.request({
      path: `annotation-types/${id}`,
      method: 'DELETE'
    });
  }

  public deleteTest(id): Observable<any> {
    return this.request({
      path: `tests/${id}`,
      method: 'DELETE'
    });
  }




  public updateAnnotation(data, id): Observable<any> {
    return this.request({
      path: `annotation-types/${id}`,
      method: 'PUT',
      body: data
    });
  }
  public updateTest(data, id): Observable<any> {
    return this.request({
      path: `tests/${id}`,
      method: 'PUT',
      body: data
    });
  }
  public exportEDF({ testId }): Observable<any> {
    return this.request({
      path: `tests/${testId}/export-edf`,
      method: 'GET',
    });
  }

  public createOrUpdate(data): Observable<any> {
    return this.request({
      path: 'tests',
      method: 'POST',
      body: data
    });
  }

  public update(data, testId): Observable<any> {
    return this.request({
      path: `tests/${testId}`,
      method: 'PATCH',
      body: data
    });
  }

  public getTestById(id): Observable<any> {
    return this.request({
      path: `tests/${id}`,
      method: 'GET'
    });
  }

  public getPatientListById(id): Observable<any> {
    const params = {
    'q': id
    }
    return this.request({
      path: `patients/patient-auto-complete/`,
      method: 'GET',
      query:removeBlank(params)
    });
  }
  public endTestManually(testId: string, config = undefined): Observable<any> {
    return this.request({
      path: `tests/${testId}/endtest`,
      method: 'POST',
      body: config
    });
  }

  /**
   * List the backup files the mobile app uploaded for a test's device, behind the
   * "Upload Backup File" action. The web BE resolves the device serial from the test
   * and returns only that device's files; callers only pass optional filters.
   * Returns `{ items, count }`.
   */
  public listMobileTestFiles(
    testId: string | number,
    params?: {
      // The device is not one of them — the BE resolves it from the test itself.
      // sent as strings — the BE DTO parses them, and removeBlank would drop a
      // literal `false`/`0`.
      unlinkedOnly?: string;
      limit?: string;
      since?: string;
      until?: string;
    },
  ): Observable<any> {
    return this.request({
      path: `test-files/${testId}/list`,
      method: 'GET',
      query: removeBlank(params ?? {}),
    });
  }

  /**
   * Forward a backup file into the test's signals (working-area) bucket. With an
   * empty body the BE forwards the file already linked to this test; pass
   * `fileId` (or `s3Path`) from listMobileTestFiles to forward a specific one.
   * The web BE mints the presigned URL itself — the client never sends one.
   */
  public forwardMobileTestFile(
    testId: string | number,
    body: {
      fileId?: number;
      s3Path?: string;
      // Which sensor units the study was recorded with, as the uploader confirmed
      // them. Nothing streamed, so this is the only thing that knows.
      units?: {
        hasChest?: boolean;
        hasLeg?: boolean;
        hasEcg?: boolean;
        hasAbdomen?: boolean;
      };
    } = {},
  ): Observable<any> {
    return this.request({
      path: `test-files/${testId}/forward`,
      method: 'POST',
      body,
    });
  }
}
